import { Injectable } from '@angular/core';
import {
    EmailPreferences,
    EmailPreferencesUpdate
} from '../../core-data-model/CompanySettings.model';
import { GeneralSettingsServer } from '../../core-data-model/GeneralSettingsApi.serverinterface';

@Injectable({
    providedIn: 'root'
})
export class GeneralSettingsApiTransformer {
    transformServerToClient(server: GeneralSettingsServer): EmailPreferences {
        return new EmailPreferences({
            isWeeklyPromotionalEmails:
                server.emailPreference.isWeeklyPromotionalEmails,
            isMonthlyNewsLetter: server.emailPreference.isMonthlyNewsLetter,
            isProductUpdates: server.emailPreference.isProductUpdates,
            isTechnicalUpdates: server.emailPreference.isTechnicalUpdates,
            isProductFeedback: server.emailPreference.isProductFeedback,
            isWebinarAndEventUpdates:
                server.emailPreference.isWebinarAndEventUpdates
        });
    }
    transformClientToServer(
        emailSettingsUpdate: EmailPreferencesUpdate
    ): GeneralSettingsServer {
        return {
            emailPreference: {
                isWeeklyPromotionalEmails:
                    emailSettingsUpdate.isWeeklyPromotionalEmails,
                isMonthlyNewsLetter: emailSettingsUpdate.isMonthlyNewsLetter,
                isProductUpdates: emailSettingsUpdate.isProductUpdates,
                isTechnicalUpdates: emailSettingsUpdate.isTechnicalUpdates,
                isProductFeedback: emailSettingsUpdate.isProductFeedback,
                isWebinarAndEventUpdates:
                    emailSettingsUpdate.isWebinarAndEventUpdates
            }
        };
    }
}
